import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/browser";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import "assets/css/material-dashboard-react.css?v=1.5.0";

import indexRoutes from "routes/index.jsx";

import { SENTRY_DSN } from "config.js";

const hist = createBrowserHistory();

Sentry.init({ dsn: SENTRY_DSN });

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      {indexRoutes.map((prop, key) => {
        return <Route path={prop.path} component={prop.component} key={key} />;
      })}
    </Switch>
  </Router>,
  document.getElementById("root")
);
